import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import colors from '../../styles/colors'

// import LanguagesSelector from '../shared/LanguagesSelector'
import Footer from '../shared/Footer'

function HomeSidebar({ className }) {
    const fontSize = 20

    const HomeSidebarContent = styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
    `
    const StyledHomeSidebarContentTitle = styled.div`
        font-size: 60px;
        font-weight: 300;
        padding: 20px 0;
    `
    const StyledHomeSidebarContentList = styled.ul`
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-size: 20px;
    `
    const StyledLanguagesSelector = styled.div``
    const StyledLink = styled(Link)`
        padding: 15px 40px;
        margin: 50px;
        background-color: ${colors.fifth};
        color: white;
        font-size: ${fontSize}px;
        text-decoration: none;
        font-weight: 400;
        border-radius: 50px;
        box-shadow: 0 0 30px #00000046;
        transition: filter 0.3s ease;

        &:hover {
            filter: brightness(0.8);
        }
    `

    return (
        <div className={className}>
            <StyledLanguagesSelector />
            <HomeSidebarContent>
                <StyledHomeSidebarContentTitle>
                    Salveat ?
                </StyledHomeSidebarContentTitle>
                <StyledHomeSidebarContentList>
                    <li>Gagnez de l'argent</li>
                    <li>Mangez moins cher</li>
                    <li>Devenez écolo !</li>
                </StyledHomeSidebarContentList>
                <StyledLink to="/Dashboard">Découvrir</StyledLink>
            </HomeSidebarContent>
            <Footer />
        </div>
    )
}

export default HomeSidebar
